import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { UserMappingRead } from '@ragu-components/ord-types';

const UserMappingsList = React.lazy(async () => import('./UserMappingsList'));

export const userMappingsResource: OrdResourceProps = {
  key: Resources.user_mappings,
  name: Resources.user_mappings,
  list: <UserMappingsList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: UserMappingRead) => record.name,
};
